/* eslint-disable no-script-url */
import React from 'react'
import SubHeading from './SubHeading'
import Card from './Card'

export default function Skills(props) {
    const cards = [
        {
            "title": "C:Advance",
            "description": "With expertise in C, I have built various projects, including a file management system, a simple text editor, and a command-line utility for data encryption.",
            "urlToImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/C_Programming_Language.svg/570px-C_Programming_Language.svg.png?20201031132917",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "C++:Advance",
            "description": "In C++, I have developed projects like a student management system using classes and inheritance, a library management system utilizing data structures, and an image processing application using the OpenCV library.",
            "urlToImage": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/459px-ISO_C%2B%2B_Logo.svg.png?20170928190710",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Java: Intermediate",
            "description": "Although I'm at an intermediate level in Java, I have worked on projects such as a simple chat application using Java sockets, a basic inventory management system, and a web application with JSP and Servlets.",
            "urlToImage": "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/java-programming-language-icon.png",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Python: Beginner",
            "description": "While I am still in the beginner stage with Python, I have completed projects like a weather forecasting script using an API, a basic data visualization tool with Matplotlib, and a text-based game using the Pygame library.",
            "urlToImage": "https://logos-download.com/wp-content/uploads/2016/10/Python_logo_icon-700x697.png",
            "date": "2 Months Ago",
            "link": null
        },
    ]
    const webDev = [
        {
            "title": "HTML:Advance",
            "description": "My expertise in HTML has been demonstrated in various projects, including a responsive landing page, a blog template, and an e-commerce product listing page.",
            "urlToImage": "https://logos-download.com/wp-content/uploads/2017/07/HTML5_logo-700x700.png",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "CSS:Advance",
            "description": "I am proficient in CSS selectors, box model, and responsive design principles. I have implemented captivating designs and layouts, such as a portfolio website with custom animations, a responsive navigation menu, and a flexible grid-based gallery, showcasing my expertise in CSS.",
            "urlToImage": "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "JavaScript: Intermediate",
            "description": "I have experience working with variables, data types, conditionals, loops, and functions. While I'm still developing my skills in JavaScript, I have utilized the language to create interactive features, such as a real-time chat feature using Socket.io and a dynamic image carousel.",
            "urlToImage": "https://logos-download.com/wp-content/uploads/2019/01/JavaScript_Logo-450x450.png",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "React-JS: Intermediate",
            "description": "I have gained familiarity with creating components, managing state, and implementing basic functionality. In a recent project, I developed a task management application using ReactJS, allowing users to create, update, and organize their tasks with a user-friendly interface.",
            "urlToImage": "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
            "date": "2 Months Ago",
            "link": null
        }
    ]
    const framework = [{
        "title": "Bootstrap",
        "description": "I have developed a responsive landing page using Bootstrap, a popular front-end framework. Leveraging the powerful grid system and pre-built components of Bootstrap, I created a visually appealing and mobile-friendly landing page for a product.",
        "urlToImage": "https://upload.wikimedia.org/wikipedia/commons/b/b2/Bootstrap_logo.svg",
        "date": "2 Months Ago",
        "link": null
    },
    {
        "title": "Tailwind CSS",
        "description": "In one of my projects, I utilized Tailwind CSS, a utility-first CSS framework, to build a customized blog template. With Tailwind CSS, I could rapidly create and customize the design by composing utility classes.",
        "urlToImage": "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
        "date": "2 Months Ago",
        "link": null
    },
    {
        "title": "Node JS",
        "description": "As an intermediate learner in Node.js, you've made significant strides in your journey towards mastering server-side JavaScript development. You're no longer a beginner, having gained a solid foundation in the fundamental concepts and practices of Node.js. You've successfully progressed beyond basic scripting to more complex and practical applications.",
        "urlToImage": "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
        "date": "2 Months Ago",
        "link": null
    },
    {
        "title": "Express JS",
        "description": "As a beginner in Express.js, you've taken your first steps into the exciting world of web application development using Node.js. You've gained a foundational understanding of how Express.js, a popular web application framework, can simplify and streamline the process of building robust and dynamic web applications.",
        "urlToImage": "https://www.hugeserver.com/kb/wp-content/uploads/2017/12/expresslogo.png",
        "date": "2 Months Ago",
        "link": null
    }]
    return (
        <>
            <SubHeading color={props.color} heading="Programming Language" />
            <div className="container my-3">
                <div className="row my-3 d-flex justify-content-center">
                    {cards.map((element) => {
                        return <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center align-item-center my-3 border-0 rounded" key={element.urlToImage} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <Card color={props.color} BGColor={props.BGColor} src={element.urlToImage} desc={element.description} title={element.title} date={element.date} imgheight={"150px"} height={"300px"} width={"20rem"} />
                        </div>
                    })}
                </div>
            </div>
            <SubHeading color={props.color} heading="Web Development" />
            <div className="container my-3">
                <div className="row my-3 d-flex justify-content-center">
                    {webDev.map((element) => {
                        return <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center align-item-center my-3 border-0 rounded" key={element.urlToImage} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <Card color={props.color} BGColor={props.BGColor} src={element.urlToImage} desc={element.description} title={element.title} date={element.date} imgheight={"150px"} height={"300px"} width={"20rem"} />
                        </div>
                    })}
                </div>
            </div>
            <SubHeading color={props.color} heading="Frameworks" />
            <div className="container my-3">
                <div className="row my-3 d-flex justify-content-center">
                    {framework.map((element) => {
                        return <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center align-item-center my-3 border-0 rounded" key={element.urlToImage} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <Card color={props.color} BGColor={props.BGColor} src={element.urlToImage} desc={element.description} title={element.title} date={element.date} imgheight={"150px"} height={"390px"} width={"20rem"} />
                        </div>
                    })}
                </div>
            </div>
        </>
    )
}
